import { gql } from '@apollo/client';

export const REGENERATE_SIGNNOW_DOCUMENT_GROUP = gql`
  mutation Flex_RegenerateSignNowDocumentGroup(
    $envelopeIds: [Int!]!
    $isEmbedded: Boolean
    $redirectUri: String
  ) {
    regenerateSignNowDocumentGroup(
      envelopeIds: $envelopeIds
      isEmbedded: $isEmbedded
      redirectUri: $redirectUri
    ) {
      id
      status
      signingUrl
      userId
      inviteExpiresAt
      envelopeIds
    }
  }
`;
